<template>
  <div>
    <div class="detail-wrapper cursor-pointer" @click="handelOpenDetail">
      <div class="absolute bottom-10 left-1 md:left-2 w-10 h-10 rounded-md block-bg"></div>
      <div class="absolute bottom-6 -left-5 md:-left-4 w-10 h-10 rounded-md block-bg"></div>
      <div class="flex items-center justify-center h-full text-white">
        <span class="text-lg md:text-xl py-2 px-4 inline-block text-bg rounded-md sm:mr-8"
          >查看详细报告</span
        >
        <div class="flex items-end justify-end">
          <img src="./assets/bg-icon.svg" class="w-10/12" />
        </div>
      </div>

      <div class="absolute bottom-16 -right-1 w-10 h-10 rounded-md block-bg"></div>
      <div class="absolute bottom-12 right-4 w-8 h-8 rounded-md block-bg"></div>
    </div>
    <Detail ref="detail" :content="content" />
  </div>
</template>

<script lang="ts">
import { Score } from '@/store/modules/common/types';
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { OptionScoreMultiple } from '../Survey/index.vue';
import Detail from './detail.vue';

const userModule = namespace('common');

@Component({
  components: {
    Detail
  }
})
export default class AnalysisReport extends Vue {
  @Prop({ type: Object }) content!: Content & {
    score: OptionScoreMultiple;
    multipleValue: string | undefined;
  };

  @userModule.State('score') score!: Score;

  mounted() {
    if (this.content.multipleValue) return;
    window.storyteller.updateAssignContent({
      $id: this.content.$id,
      $kind: this.content.$kind,
      ...{
        multipleValue: JSON.stringify([...this.score.multipleValue]),
        selection_id: this.score.selection_id,
        duration: this.score.duration
      }
    });

    this.$nextTick(() => {
      this.$store.commit('common/setScore', {
        status: '',
        visible: false,
        multipleValue: new Map()
      });
    });
  }

  handelOpenDetail() {
    (this.$refs.detail as Vue & { open: Function }).open();
  }
}
</script>
<style scoped>
.detail-wrapper {
  @apply relative w-full sm:w-120 h-32 mb-8 md:ml-12 rounded-motif;
  max-width: 30rem;
  background: linear-gradient(89deg, #9d87fd -3%, #9d8bfe 102%);
  transition: 0.3s;
  animation: boingInUp 1.5s;
}

.detail-wrapper:hover {
  transform: translateY(-0.25rem);
}

.block-bg {
  background-color: rgba(255, 255, 255, 0.1);
}

.text-bg {
  background-color: rgba(255, 255, 255, 0.14);
}

@-webkit-keyframes boingInUp {
  0% {
    transform: perspective(800px) rotateX(-50deg);
    transform-origin: 50% 0%;
    opacity: 0;
  }
  25% {
    transform: perspective(800px) rotateX(50deg);
    transform-origin: 50% 0%;
    opacity: 1;
  }
  60% {
    transform: perspective(800px) rotateX(-25deg);
    transform-origin: 50% 0%;
    opacity: 1;
  }
  70% {
    transform: perspective(800px) rotateX(13deg);
    transform-origin: 50% 0%;
    opacity: 1;
  }
  80% {
    transform: perspective(800px) rotateX(-6deg);
    transform-origin: 50% 0%;
    opacity: 1;
  }
  90% {
    transform: perspective(800px) rotateX(3deg);
    transform-origin: 50% 0%;
    opacity: 1;
  }
  100% {
    transform: perspective(800px) rotateX(0deg);
    transform-origin: 50% 0%;
    opacity: 1;
  }
}
</style>
